import React, { createContext, useContext } from 'react';
var DEFAULT_FLAG_STATE = {};
export var FeatureFlagsContext = /*#__PURE__*/createContext(DEFAULT_FLAG_STATE);
export var FeatureFlagsProvider = function FeatureFlagsProvider(_ref) {
  var children = _ref.children,
    _ref$flags = _ref.flags,
    flags = _ref$flags === void 0 ? DEFAULT_FLAG_STATE : _ref$flags;
  return /*#__PURE__*/React.createElement(FeatureFlagsContext.Provider, {
    value: flags
  }, children);
};
export var useFeatureFlag = function useFeatureFlag(key, defaultValue) {
  var flags = useContext(FeatureFlagsContext);
  var value = flags[key];
  if (typeof value === 'undefined') {
    return defaultValue;
  }
  return value;
};